<template>
  <div class="goodsGroup">
    <div class="screen">
      <span>实时数据</span>
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          今天
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>今天</el-dropdown-item>
          <el-dropdown-item>前一周</el-dropdown-item>
          <el-dropdown-item>前半个月</el-dropdown-item>
          <el-dropdown-item>前一年</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="time">数据更新时间：12-09 14:23</div>
    <div class="newData">
      <div class="card" v-for="(item, index) in newData" :key="index">
        <div class="text">{{ item.text }}</div>
        <div class="numParice">{{ item.num }}</div>
        <div class="compare_hint">较上周一</div>
        <div class="compare">{{ item.compare }}</div>
      </div>
    </div>
    <div id="Dataechart"></div>
  </div>
</template>

<script>
import echarts from 'echarts';
export default {
  data() {
    return {
      charts: "",
      /*  opinion: ["1", "3", "3", "4", "5"],*/
      opinionData: ["3", "2", "4", "4", "5", "1", "2"],
      newData: [
        {
          text: "实收金额",
          num: "￥150",
          compare: "-5%"
        },
        {
          text: "应收金额",
          num: "￥150",
          compare: "-5%"
        },
        {
          text: "订单数",
          num: "150",
          compare: "-5%"
        },
        {
          text: "笔单价",
          num: "￥150",
          compare: "-5%"
        },
        {
          text: "应收金额",
          num: "￥150",
          compare: "-5%"
        }
      ]
    };
  },
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
      this.charts = echarts.init(document.getElementById("Dataechart"));
      this.charts.setOption({
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["近七日收益"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },

        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["1", "2", "3", "4", "5", "6", "7"]
        },
        yAxis: {
          type: "value"
        },

        series: [
          {
            name: "近七日收益",
            type: "line",
            stack: "总量",
            data: this.opinionData
          }
        ]
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.goodsGroup {
  width: 100%;
  padding: 15px 25px;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  .screen {
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 20px;
    .el-dropdown {
      margin-left: 10px;
    }
  }
  .time {
    margin-bottom: 20px;
    color: #999999;
    font-size: 12px;
  }
  .newData {
    display: flex;
    flex-direction: row;
    .card {
      text-align: center;
      margin: 0 5px;
      min-height: 180px;
      flex: 1;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
      border-radius: 6px;
      border: 1px solid rgba(238, 238, 238, 1);
      font-size: 12px;
      font-weight: 400;
      .text {
        margin-top: 24px;
        color: rgba(51, 51, 51, 1);
      }
      .numParice {
        font-size: 26px;
        margin-top: 15px;
      }
      .compare_hint {
        margin-top: 30px;
      }
      .compare {
        color: #42d100;
        margin-top: 10px;
      }
    }
  }
  #Dataechart {
    width: 100%;
    height: 240px;
  }
}
</style>

<style lang="scss">
.goodsGroup {
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
}
</style>
